/**
 * Created by yz on 2017/3/27.
 */
{
    angular
        .module("dataModule")
        .factory("request.order", order);
    order.$inject = ['$q',"requestHandler","utils.constant","utils.currentUser"];
    function order($q,requestHandler,constant,currentUser) {
        let collect={
            'getPrintSizeSelection':getPrintSizeSelection,
            'createOrder':createOrder,
            'getOrderInfo':getOrderInfo,
            'getPayQrcode':getPayQrcode,
            // 'getPayUrl':getPayUrl,
            'checkPayResult':checkPayResult,
            'setOrderPaid':setOrderPaid,
            'getPrintQrcode':getPrintQrcode,
            'getOrderList':getOrderList,
            'cancelOrder':cancelOrder,
            'modifyOrder':modifyOrder,
            'refundApply':refundApply,
            'getRefundDetail':getRefundDetail,
            'setRechargeInfo':setRechargeInfo , //设置充值信息函数
            'setRechargeOrderId':setRechargeOrderId,
            'getAreaList':getAreaList,
            'setAreaList':setAreaList,
        }
        return collect;

        function getAreaList(){

            return requestHandler.simpleRequest(constant.action.arealist,'',
                function(respone){
                    console.log(respone);
                    let data={};
                    data.result=respone.data[0].result;
                    if(data.result==1){
                        data.area=respone.data[0].area;
                    }

                    return data;
                });
        }

        function setAreaList(areaid,userid){

            let url = constant.action.setarealist + "?userid=" + userid + "&areaid=" + areaid;
            console.log("setAreaList:" + url);
            return requestHandler.simpleRequest(url,'',
                function(respone){
                    console.log(respone);
                    let data={};
                    data.result=respone.data[0].result;
                    if(data.result==1){
                        data.area=respone.data[0].area;
                    }

                    return data;
                });
        }

        function getPrintSizeSelection(areaid){

            let url = constant.action.printSizeSelection + "?areaid=" + areaid;
            return requestHandler.simpleRequest(url,'',
                function(respone){
                    console.log(respone);
                    let data={};
                    data.result=respone.data[0].result;
                    if(data.result==1){

                        let printsizeList=[];
                        for(let i in respone.data[0].pagesize.rows){

                            let responeData=respone.data[0].pagesize.rows[i];
                            if (responeData.title != "证件照")
                            {
                                printsizeList.push(responeData);
                            }
                        }

                        data.sizeList=printsizeList;
                    }
                    
                    return data;
                });
        }

        //创建订单
        //需要用户id，须在获取用户信息后再调用
        function createOrder(docData,sizeFormat,printType,printMode,copiesNum,singleSidedNum,areaid){
            // console.log(currentUser.info);
            let params={
                'userid':currentUser.info.userId,
                'printsizetitle':sizeFormat.title,
                'printsizewidth':sizeFormat.width,
                'printsizeheight':sizeFormat.height,
                'printnums':copiesNum,
                'printmode':printMode,
                'singlepagenum':singleSidedNum,
                'docid':docData.docId,
                'printtype':printType,
                'docname':docData.fileName,
                'docpages':docData.pageNum,
                // 'pricepage':
                // 'discount'
                // 'docprice'
                // 'discountprice'
                // 'pricetotal'
            };
            let paperNum=0;
            if(printType==0){
                paperNum=Math.ceil((docData.pageNum)/printMode);
            }else{
                paperNum=singleSidedNum+Math.ceil((docData.pageNum-singleSidedNum)/2);
            }
            if(printMode==1){
                params.pricepage=sizeFormat.pricepage;
                params.discount=sizeFormat.discount;
            }else if(printMode==2){
                params.pricepage=sizeFormat.pricepage_d;
                params.discount=sizeFormat.discount_d;
            }

            params.docprice=params.pricepage*paperNum;
            params.discountprice=params.docprice*params.discount/100;
            params.pricetotal=params.discountprice*copiesNum;

            params.areaid=areaid;

            let paramsStr='orderinfo='+JSON.stringify([params]);
            /*
            * log start
            * */
            let _logdata = [{
                "querytype":0,
                "userid": currentUser.info.userId,
                "logcontent":'创建订单：'+paramsStr

            }];
            let paramslog='debuglog='+JSON.stringify(_logdata);
            requestHandler.simpleRequest(constant.action.debuglog, paramslog,function (data) {
                console.log("debug返回：",data);
            });
            /*
            * log end
            * */
            let action=printType==1?constant.action.createPaperOrder:constant.action.createOrder;
            return requestHandler.simpleRequest(action,paramsStr,
                function(respone){
                    // console.log(respone.data[0]);
                    // def.resolve(resultData);
                    let data={};
                    data.result=respone.data[0].result;
                    if(data.result==1){
                        data.orderId=respone.data[0].orderid;
                        
                    }
                    // console.log(data)
                    return data;
                });
        }

        //获取订单信息
        function getOrderInfo(orderId){

            let params=[{
                'orderid':orderId
            }];
            let paramsStr='queryinfo='+JSON.stringify(params);
            let p1=requestHandler.simpleRequest(constant.action.ordersquery_printagain,paramsStr,
                function(respone){
                    //console.log("订单信息1",respone.data);

                    return respone.data;
                });

            params=[{
                'orderid':orderId
            }];
            paramsStr='orderprintinfo='+JSON.stringify(params);
            let p2= requestHandler.simpleRequest(constant.action.orderList_print,paramsStr,
                function(respone){
                    //console.log("订单信息2",respone);
                    return respone.data;
                });

            return $q.all([p1,p2]).then(function(datas){
                //console.log("合并数据1",datas[0],datas[1]);

                //console.log("合并数据2",datas[0].rows[0],datas[1][0].orderprint.rows[0]);
                if(JSON.stringify(datas[0]) == "{}"){
                    var responeData= datas[1][0].orderprint.rows[0];

                }else{
                    var responeData=jQuery.extend(datas[0].rows[0],datas[1][0].orderprint.rows[0]);

                }


               // console.log("合并数据3",responeData)
                let docInfo={
                    'docId':responeData.docid,
                    'fileName':responeData.filename,
                    'pageNum':parseInt(responeData.docpages),
                    'uploadDate':Date.parse(responeData.orderdate),
                    'pagecount':parseInt(responeData.pagecount)//加 08-26
                };
                let printInfo={
                    'printType':responeData.printtype,
                    'size_title':responeData.pagetitle,
                    'size_width':responeData.pagewidth,
                    'size_height':responeData.pageheight,
                    'printMode':responeData.printmode,
                    'singleSidedNum':parseInt(responeData.singlepagenum),
                    'copiesNum':parseInt(responeData.printnum),
                    'price':parseFloat(responeData.printprice),
                    'discount':parseInt(responeData.discount),
                    'newdiscount':parseInt(responeData.newdiscount),
                    'areaname':responeData.areaname
                };
                if(printInfo.printType=="普通打印"){//0906前 printInfo.printType=="0"
                   // console.log("printMode",printInfo.printMode);
                   // console.log("pageNum",docInfo.pageNum);
                    //返回的printMode为1 2
                    printInfo.paperNum=Math.ceil((docInfo.pageNum)/printInfo.printMode);
                }else{
                    printInfo.paperNum=printInfo.singleSidedNum+Math.ceil((docInfo.pageNum-printInfo.singleSidedNum)/2);
                }

                let orderInfo={
                    'orderId':responeData.orderid,
                    'orderPrintId':responeData.orderprintid,
                   // 'amount':parseFloat(responeData.pricetotal),//before 0907
                    'amount':responeData.paid?parseFloat(responeData.paid):parseFloat(responeData.pricetotal),
                    'status':responeData.printstatus,
                    'printDate':Date.parse(responeData.printdate),
                    'printDate_c':Date.parse(responeData.printdate_c),
                    'canprintagain':responeData.canprintagain,//判断是否可以再次打印 1可以 0不可以
                    'userid':responeData.userid,
                    'orderstatus':responeData.orderstatus
                };
                return {
                    'docInfo':docInfo,
                    'printInfo':printInfo,
                    'orderInfo':orderInfo
                };
            })
        }

        //payType：0-支付宝，1-微信    请求获取支付二维码
        function getPayQrcode(payType,orderId,fileName,amount){
            if(payType==1){
                let params={ 
                    'out_trade_no': orderId, 
                    'subject': fileName, 
                    'total_amount': amount *100
                };
                //获取微信支付二维码接口constant.action.qrpay_wechat
                return requestHandler.simpleRequest(constant.action.qrpay_wechat,params,
                    function(respone){
                        //console.log('微信二维码成功',respone);

                        return respone.data;
                    });
            }else if(payType==0){

                let params={ 
                    'out_trade_no': orderId, 
                    'subject': fileName, 
                    'total_amount': amount 
                };
                //获取支付宝支付二维码接口constant.action.qrpay_ali
                return requestHandler.simpleRequest(constant.action.qrpay_ali,params,
                    function(respone){
                       // console.log('支付宝二维码成功',respone);

                        return respone.data;
                    });
            }
        }

        // function getPayUrl(payType,orderId,fileName,amount){
        //     let params={ 
        //         'WIDout_trade_no': orderId, 
        //         'WIDsubject': fileName, 
        //         'WIDtotal_amount': amount 
        //     };
        //     return requestHandler.simpleRequest(constant.action.appPay_ali,params,
        //         function(respone){
        //             // console.log(respone);

        //             return respone.data;
        //         });
        // }

        function checkPayResult(payType,orderId,paiddate){
            if(payType==1){
                let params={ 
                    'out_trade_no': orderId
                };
                //微信检测是否完成支付接口：constant.action.checkPayResult_wechat
                return requestHandler.simpleRequest(constant.action.checkPayResult_wechat,params,
                    function(respone){
                        //console.log(respone.data);

                        return respone.data;
                    });
            }else{
                let params={ 
                    'out_trade_no': orderId
                };
                //支付宝检测是否完成支付接口constant.action.checkPayResult_ali
                return requestHandler.simpleRequest(constant.action.checkPayResult_ali,params,
                    function(respone){
                        //console.log(respone.data);

                        return respone.data;
                    });
            }
            
        }

        //设置订单状态为已支付
        function setOrderPaid(orderPrintId,amount,payType,paiddate,discount){
            let params={
                'orderprintid':orderPrintId,
                'price' : amount,
                'paytype':payType,
                'discount':discount,
                'paiddate':paiddate
            };
            let paramsStr='custompay='+JSON.stringify([params]);
            return requestHandler.simpleRequest(constant.action.setOrderPaid,paramsStr,
                function(respone){
                    //console.log(respone.data);

                    return respone.data;
                });
        }


        //获取打印二维码
        function getPrintQrcode(orderId){
            let params={
                'qrcode':orderId
            };
            let paramsStr='qrcodeinfo='+JSON.stringify([params]);
            //访问获取打印二维码接口
            return requestHandler.simpleRequest(constant.action.printQrcode,paramsStr,
                function(respone){
                    //console.log(respone.data);

                    return respone.data;
                });
        }

        //获取订单列表；需要用户id，须在获取用户信息后再调用
        function getOrderList(status){
            
            let params=[{
                'userid':currentUser.info.userId,
                // 'orderid':orderId,
                'querymode' : 1,//值为1时，只查与userid关联的订单 值为2时，查询所有的订单
                'querytype' : status,// 0:所有订单
                                    //1:待支付
                                    // 5:待打印
                                    // 2:已打印
                                    // 4:已取消
                                    // 3:已完成
            }];
            let paramsStr='queryinfo='+JSON.stringify(params);
            return requestHandler.simpleRequest(constant.action.orderSearch,paramsStr,
                function(respone){
                    //console.log(respone);
                    let orderList=[];
                    for(let i in respone.data.rows){

                        let responeData=respone.data.rows[i];
                        let data={
                            'orderId':responeData.orderid,
                            'docId':responeData.docid,
                            'pageNum':parseInt(responeData.pagecount),
                            'fileName':responeData.filename,
                            'printType':responeData.printtype,
                            'status':responeData.printstatus,
                            'uploadDate':Date.parse(responeData.orderdate),
                            'printDate_c':Date.parse(responeData.printdate_c),
                            //'amount':parseFloat(responeData.pricetotal),//before 0907
                            'amount':responeData.pricepaid?parseFloat(responeData.pricepaid):parseFloat(responeData.pricetotal),
                            'canprintagain':responeData.canprintagain,
                            'orderstatus':responeData.orderstatus,
                            'areaname':responeData.areaname
                        };
                        // console.log(typeof responeData.pricetotal);
                        // console.log(responeData.pricetotal);
                        // console.log(typeof data.amount);
                        // console.log(data.amount);
                        // console.log(data.amount*100);
                        orderList.push(data);
                    }
                    return orderList;
                    
                });

        }

        function cancelOrder(orderId){
            let params={
                'orderprintid':orderId
            };
            let paramsStr='orderprintinfo='+JSON.stringify([params]);
            return requestHandler.simpleRequest(constant.action.cancelOrder,paramsStr,
                function(respone){
                    // console.log(respone.data);

                    return respone.data[0];
                });
        }

        //修改订单
        function modifyOrder(orderId,orderPrintId,docData,sizeFormat,printType,printMode,copiesNum,singleSidedNum){
            let params={
                'orderid':orderId,
                'orderprintid':orderPrintId,
                'printsizetitle':sizeFormat.title,
                'printsizewidth':sizeFormat.width,
                'printsizeheight':sizeFormat.height,
                'printnums':copiesNum,
                'singlepagenum':singleSidedNum,
                'printmode':printMode
            };
            let paperNum=0;
            if(printType==0){
                paperNum=Math.ceil((docData.pageNum)/printMode);
            }else{
                paperNum=singleSidedNum+Math.ceil((docData.pageNum-singleSidedNum)/2);
            }
            if(printMode==1){
                params.pricepage=sizeFormat.pricepage;
                params.discount=sizeFormat.discount;
            }else if(printMode==2){
                params.pricepage=sizeFormat.pricepage_d;
                params.discount=sizeFormat.discount_d;
            }
            params.docprice=params.pricepage*paperNum;
            params.discountprice=params.docprice*params.discount/100;
            params.pricetotal=params.discountprice*copiesNum;

            let paramsStr='orderinfo='+JSON.stringify([params]);
            /*
            * log start
            * */
            let _logdata = [{
                "querytype":0,
                "userid": currentUser.info.userId,
                "logcontent":'修改订单：'+paramsStr

            }];
            let paramslog='debuglog='+JSON.stringify(_logdata);
            requestHandler.simpleRequest(constant.action.debuglog, paramslog,function (data) {
                //console.log("debug返回：",data);
            });
            /*
            * log end
            * */
            return requestHandler.simpleRequest(constant.action.modifyOrder,paramsStr,
                function(respone){
                    // console.log(respone.data[0]);
                    // def.resolve(resultData);
                    let data={};
                    data.result=respone.data[0].result;
                    if(data.result==1){
                        data.orderId=respone.data[0].orderid;
                        
                    }
                    // console.log(data)
                    return data;
                });
        }

        function refundApply(orderId,orderPrintId,reason,desc,imgs){
            let params={ 
                'userid':currentUser.info.userId,
                'orderid': orderId,
                'orderprintid': orderPrintId,
                'refundreason': reason,
                'refunddesc': desc
            };
            for(let i=0;i<imgs.length;i++){
                params['img'+(i+1)]=imgs[i].name;
            }
            let paramsStr='orderinfo='+JSON.stringify([params]);
            return requestHandler.simpleRequest(constant.action.orderRefundApply,paramsStr,
                function(respone){
                    //console.log(respone.data);

                    return respone.data;
                });
        }

        function getRefundDetail(orderId){
            let params={ 
                'orderid': orderId
            };
            let paramsStr='orderinfo='+JSON.stringify([params]);
            return requestHandler.simpleRequest(constant.action.orderRefundDetail,paramsStr,
                function(respone){
                    //console.log(respone.data);
                    let data=respone.data[0].refund.rows[0];
                    let refundInfo={
                        'orderId':data.orderid,
                        'orderPrintId':data.orderprintid,
                        'applyDate':Date.parse(data.committime),
                        'refundReason':data.refundreason,
                        'refundDesc':data.refunddesc,
                        'refundStatus':data.refundresp,
                        'refuseDesc':data.refusedesc
                    }
                    let resultData={
                        'result':respone.data[0].result,
                        'refundInfo':refundInfo
                    }

                    return resultData;
                });
        }

        //充值成功，设置充值信息
        //用户账号, 充值金额，充值平台，充值单号，交易类型，赠送比例
        function setRechargeInfo(userid,amount,paytype,orderId,transtype){
            let params = {
                userid : userid,
                amount : amount,
                paytype : paytype,
                transid : orderId,           //充值时用这个transid参数
                transtype : transtype,

            }
            let paramsStr='transaction='+JSON.stringify([params]);
            return requestHandler.simpleRequest(constant.action.balancetransaction,paramsStr,
                function(respone){
                    //console.log(respone.data);
                    console.log('充值成功信息：',respone);
                    //alert('后台充值成功');
                    return respone.data;
                });
        }

        //生成充值订单：
        function setRechargeOrderId(userId){
            let _data = new Date();
            let year = _data.getFullYear(),
                month= _data.getMonth() + 1,
                data = _data.getDate(),
                hour = _data.getHours(),
                minutes = _data.getMinutes(),
                seconds = _data.getSeconds();
            //console.log(year , month , data , hour , minutes , seconds);
            let strOrderId = userId + year + month + data + hour + minutes + seconds;
            if (strOrderId.length > 30)
            {
                strOrderId = strOrderId.substring(0, 29);
            }

            console.log("recharge id: [" + strOrderId + "]");

            return   (strOrderId) ;
        }
    }

}